import request from '@/utils/request'

// 查询兑换记录列表分页
export function fetchList(query) {
    return request({
        url: '/integral/order/page',
        method: 'get',
        params: query,
    })
}
// 查询兑换记录列表不分页
export function categoryList(query) {
    return request({
        url: '/order/deliver',
        method: 'get',
        params: query,
    })
}
// 查询兑换记录详细
export function getObj(id) {
    return request({
        url: '/integral/order/detail?id=' + id,
        method: 'get',
    })
}
// 发货
export function addObj(data) {
    return request({
        url: '/integral/order/deliver',
        method: 'post',
        data: data,
    })
}

// 修改兑换记录
export function putObj(data) {
    return request({
        url: '/integral/order/deliver',
        method: 'post',
        data: data,
    })
}
// 删除兑换记录
export function delObj(data) {
    return request({
        url: '/integral/category/delete',
        method: 'post',
        data: data,
    })
}